<template>
  <div>
    <div style="background-color: white; padding: 15px;">
      <div style="padding-bottom: 15px; border-bottom: 1px solid #e7e7e7">
        <span style="font-size: 13px; color:#97a8be">首页 / 红包雨管理 / 红包雨配置 / 创建</span>
      </div>
      <div style="padding-top: 15px;">
        <table width="100%">
          <tr>
            <td class="leftTd">
              日期
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="day" class="boxText"/>
              yyyy-MM-dd
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              开始时间
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="startHour" style="width: 120px" class="boxText"/> 时
              <input v-model="startMin" style="width: 120px" class="boxText"/> 分

            </td>
          </tr>
          <tr>
            <td class="leftTd">
              截止时间
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="endHour" style="width: 120px" class="boxText"/> 时
              <input v-model="endMin" style="width: 120px" class="boxText"/> 分
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              持续时长
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="timeNum" class="boxText"/>
              秒
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              金额概率配置
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <textarea v-model="config" style="width: 98%; height: 200px" class="boxText"></textarea>
              最小金额-最大金额/概率, 例如(1-10/10,)
            </td>
          </tr>
        </table>
      </div>

      <div style="padding-top: 15px; padding-bottom: 25px; padding-left: 150px">
        <input @click="addAdmin" type="button" style="cursor: pointer; padding: 10px 25px; border-radius: 3px; background-color: #1890ff; border: 1px solid #1890ff; color: white" value="创建" />
        <input @click="goback" type="button" style="cursor: pointer; padding: 10px 25px; border-radius: 3px; background-color: #ffffff; border: 1px solid #dbdbdb; margin-left: 15px; color: #606266" value="返回" />
      </div>
    </div>

  </div>
</template>

<script>

import {closeLoading, DO_NET_URL, loading, toask} from "@/config/config";
import {axiosGet, axiosPost, axiosPostJson} from "@/main";

export default {
  name: "AddRerConfig",
  data(){
    return{
      day:"",
      startHour:"",
      startMin:"",
      endHour:"",
      endMin:"",
      timeNum:"",
      config:"",
    }
  },
  mounted(){
    let that=this
    if(localStorage.getItem("iwa_token")==null||localStorage.getItem("iwa_token")==""){
      setTimeout(function (){
        that.$router.replace('index')
      },600);
    }
  },
  methods: {
    addAdmin(){
      let that=this
      if(this.day==""){
        toask("请输入日期！",6)
        return
      }
      if(this.startHour==""){
        toask("请输入开始小时！",6)
        return;
      }
      if(this.startMin==""){
        toask("请输入开始分钟！",6)
        return;
      }
      if(this.endHour==""){
        toask("请输入截止小时！",6)
        return;
      }
      if(this.endMin==""){
        toask("请输入截止分钟！",6)
        return;
      }
      if(this.timeNum==""){
        toask("请输入持续时长（秒）！",6)
        return;
      }
      if(this.config==""){
        toask("请输入金额概率配置！",6)
        return;
      }
      loading("请求中")
      let param="day="+this.day+"&startHour="+this.startHour+"&startMin="+this.startMin+"&endHour="+this.endHour
          +"&endMin="+this.endMin+"&timeNum="+this.timeNum+"&config="+this.config
      axiosPost(DO_NET_URL+"Rer/AddRer?"+param,"",function (res){
        closeLoading()
        if(res.code==200){
          toask("创建成功",6)
          setTimeout(function (){
            that.$emit("send",'rerConfig')
          },600)
        }else{
          toask(res.data,6)
        }
      })
    },
    goback(){
      this.$emit("send",'rerConfig')
    },

  }
}
</script>

<style scoped>
.boxText{-webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: 12px;
  height: 40px;
  /*line-height: 40px;*/
  outline: none;
  padding: 0 15px;
  -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  width: 50%;}
.leftTd{text-align: right;
  vertical-align: middle;
  font-size: 12px;
  color: #606266;
  line-height: 40px;
  padding: 15px 12px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;font-weight: 700; width: 120px}
.addBtn{color: #1890ff;background: #e8f4ff; border: 1px solid #1890ff; cursor: pointer; float: left; font-size: 12px;padding: 7px 15px;border-radius: 3px;}
.th{border-bottom:1px solid #dfe6ec; text-align: left; padding:0 10px;word-break: break-word;background-color: #f8f8f9;color: #515a6e;height: 40px;font-size: 12px;}
.td{border-bottom:1px solid #dfe6ec;padding:0 10px; word-break:break-word;background-color: #ffffff;color: #606266;height: 40px;font-size: 12px;}
</style>